export {
  default 
} from "./productFullDetail";
